import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  whyChooseUs: {
    fontFamily: Theme.typography.base.regular,
  },
  sectionWrapper: {
    maxWidth: '1080px',
  },
  reasonsText: {
    fontFamily: Theme.typography.base.regular,
    '& h4': {
      color: Theme.palette.gray[800],
      fontSize: Theme.typography.size[6],
      lineHeight: '150%',
      fontWeight: '400',
      margin: '10px 0 0 0',
      [Theme.breakpoints.up('lg')]: {
        fontSize: Theme.typography.size[7],
      },
    },
    '& p': {
      fontSize: Theme.typography.size[1],
      lineHeight: '150%',
      margin: '14px 0 14px 0',
      [Theme.breakpoints.up('sm')]: {
        margin: '10px 0 30px 0',
      },
      color: Theme.palette.gray[750],
      [Theme.breakpoints.up('lg')]: {
        fontSize: Theme.typography.size[3],
      },
    },
  },
  reasonsIconWrapper: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    gap: 20,
    '& h4': {
      color: Theme.palette.text.brand,
      fontSize: Theme.typography.size[6],
      lineHeight: '150%',
      fontWeight: '400',
      margin: '0',
      padding: '0 20px',
      textAlign: 'center',
      [Theme.breakpoints.up('lg')]: {
        fontSize: Theme.typography.size[7],
        padding: '0',
      },
    },
  },
  reasonsIconFlightBy: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    '& svg:first-child': {
      margin: '20px 0 20px 0',
      height: '200px',
      width: '200px',
      [Theme.breakpoints.up('sm')]: {
        height: '320px',
        width: '320px',
      },
      [Theme.breakpoints.up('xl')]: {
        height: '384px',
        width: '384px',
      },
    },
    '& svg:last-child': {
      height: '35px',
      width: '263px',
      [Theme.breakpoints.up('sm')]: {
        height: '56px',
        width: '416px',
      },
    },
  },
  reasonsIconList: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: '12px',
    width: '100%',
    [Theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      justifyContent: 'center',
    },
  },

  reasonsIcon: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    [Theme.breakpoints.up('md')]: {
      flex: '1 1 0',
      minWidth: 0,
    },
    '& h5': {
      fontFamily: Theme.typography.base.semiBold,
      fontSize: Theme.typography.size[5],
      color: Theme.palette.text.brand,
      textTransform: 'uppercase',
      textAlign: 'center',
      margin: 0,
      [Theme.breakpoints.up('lg')]: {
        fontSize: Theme.typography.size[6],
      },
      [Theme.breakpoints.up('xl')]: {
        fontSize: Theme.typography.size[7],
      },
    },
    '& p': {
      fontFamily: Theme.typography.base.regular,
      fontSize: Theme.typography.size[1],
      color: Theme.palette.gray[800],
      textAlign: 'center',
      margin: '8px 0 24px 0',
      [Theme.breakpoints.up('sm')]: {
        fontSize: Theme.typography.size[5],
      },
      [Theme.breakpoints.up('lg')]: {
        padding: '0 10px',
      },
      [Theme.breakpoints.up('xl')]: {
        fontSize: Theme.typography.size[7],
      },
    },
    '& svg': {
      height: '80px',
      width: '80px',
      marginBottom: '16px',
      [Theme.breakpoints.up('md')]: {
        height: '111px',
        width: '111px',
        marginBottom: '24px',
      },
    },
  },
}));

export default useStyles;
